import { Component, OnDestroy } from '@angular/core';
import { LanguageService } from './services/language.service';
import { Observable } from 'rxjs';
import { HttpService } from './services/http.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent implements OnDestroy {

  title = 'skm-rol';
  language: string;
  footer: any;

  langObsSubscr: any;
  footerObsSubscr: any;

  interval: any;
  opacity = 1;

  constructor(private languageService: LanguageService, http: HttpService) {

    this.langObsSubscr = this.languageService.languageObs().subscribe((language: string) => {
      if (language === 'pl') { this.language = 'en'; }
      if (language === 'en') { this.language = 'pl'; }

      if (this.langObsSubscr === undefined) {
        this.langObsSubscr = http.footerObservable().subscribe(data => {
          this.footer = data;
        });
      }

      http.getText('footer', language);

    });


    setTimeout(() => { this.opacity++; }, 1000);

    this.interval = setInterval(() => {
      if (this.opacity < 4) { this.opacity++; } else { this.opacity = 1; }
    }, 7000);

  }

  ngOnDestroy() {
    this.langObsSubscr.unsubscribe();
  }

  changeLanguage(language: string) {
    this.languageService.switchLanguage(language);
  }

}
